import { render } from "./PageGroupReportTile.vue?vue&type=template&id=2caf43ab"
import script from "./PageGroupReportTile.vue?vue&type=script&lang=js"
export * from "./PageGroupReportTile.vue?vue&type=script&lang=js"

import "./PageGroupReportTile.vue?vue&type=style&index=0&id=2caf43ab&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__